// UI Element Hiding Logic for Different User Roles
// Cache selectors for better performance
const selectors = {
    menuBtnGroup: '.menu-btn-group',
    pageIconGroup: '.page-icon-group',
    prevDocBtn: '.prev-doc',
    nextDocBtn: '.next-doc',
    sidebarToggle: '.sidebar-toggle-btn, .sidebar-toggle-icon, [data-action="toggle_sidebar"]',
    commentCount: '.comment-count.d-flex.align-items-center',
    separatorDot: '.mx-2',
    likeButton: '.list-row-like.hidden-xs',
    helpButton: '.dropdown-help .btn-reset.nav-link'
};

$(document).on('page-change', function() {
    const isAdmin = frappe.session.user === "Administrator" || frappe.user.has_role("Super Admin");

    const route = (frappe.get_route && frappe.get_route()) || [];
    const isFormView = route[0] === "Form";
    const isListView = route[0] === "List";
    const isReportRoute = route.includes("Report");

    $(document.body).toggleClass('ic-hide-form-sidebar', isFormView);
    $(document.body).toggleClass('ic-hide-list-sidebar', isListView);
    $(document.body).toggleClass('user-is-admin', isAdmin);
    
    if (!isAdmin) {
        // Hide elements for non-administrator users (but NOT sidebar on desk)
        $(selectors.menuBtnGroup).hide();
        $(selectors.pageIconGroup).hide();
        
        if (isFormView) {
            setTimeout(() => {
                $('.btn.btn-default.icon-btn').hide();
                $(selectors.menuBtnGroup).hide();
            }, 300);
        }
    }
    
    // Hide comment count, separator, and like button from all list views
    if (isListView) {
        hideListRowElements();
    }
    
    // Condition when route is "Report"
    if (isReportRoute && !isAdmin) {
        $(selectors.menuBtnGroup).show();
        console.log('Report route detected');
        
        // Hide all menu items except "Pick Columns"
        setTimeout(() => {
            $(selectors.menuBtnGroup).find('li').each(function() {
                const $li = $(this);
                const label = ($li.find('[data-label]').attr('data-label') || '').trim();
                if (label !== 'Pick%20Columns' && label !=="Export") {
                    $li.hide();
                }
            });
        }, 100);
    }
});

// Function to hide list row elements
function hideListRowElements() {
    // Use CSS for better performance and persistence
    if (!$('#list-row-hide-style').length) {
        let style = document.createElement('style');
        style.id = 'list-row-hide-style';
        style.innerHTML = `
            .list-row-activity .comment-count.d-flex.align-items-center,
            .list-row-activity .mx-2,
            .list-row-activity .list-row-like.hidden-xs,
            .level-item.list-row-activity .comment-count,
            .level-item.list-row-activity .mx-2,
            .level-item.list-row-activity .list-row-like,
            .dropdown-help .btn-reset.nav-link {
                display: none !important;
            }
        `;
        document.head.appendChild(style);
    }
}

// MutationObserver to catch dynamically added elements
let observer;
function startListRowObserver() {
    if (observer) observer.disconnect();
    
    observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1) { // Element node
                        // Check if this node or its children contain the elements we want to hide
                        const $node = $(node);
                        if ($node.hasClass('list-row-activity') || $node.find('.list-row-activity').length || 
                            $node.hasClass('dropdown-help') || $node.find('.dropdown-help').length) {
                            setTimeout(hideListRowElements, 100);
                        }
                    }
                });
            }
        });
    });
    
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}

// Start observer when page loads
$(document).ready(function() {
    startListRowObserver();
});

$(document).on('show.bs.dropdown', '.actions-btn-group', function() {
    if (frappe.session.user === "Administrator" || frappe.user.has_role("Super Admin")) return;

    const route = (frappe.get_route && frappe.get_route()) || [];
    const isListView = route[0] === "List";
    if (!isListView) return;

    const $menu = $(this).find('.dropdown-menu');
    if (!$menu.length) return;

    $menu.find('li').each(function() {
        const $li = $(this);
        const label = ($li.find('[data-label]').attr('data-label') || '').trim();
        if (label === 'Export') {
            $li.show();
        } else {
            $li.hide();
        }
    });
});

// Hide toggle + navigation buttons in form views (sidebar is removed via CSS marker class)
frappe.ui.form.on('*', {
    refresh: function(frm) {
        // Hide navigation buttons for all users
        setTimeout(() => {
            $(selectors.prevDocBtn).hide();
            $(selectors.nextDocBtn).hide();
            $('.btn-prev-doc').hide();
            $('.btn-next-doc').hide();
            $('[data-label="Previous Document"]').parent().hide();
            $('[data-label="Next Document"]').parent().hide();
        }, 300);

        // Hide sidebar toggle for all users in form views
        setTimeout(() => {
            $(selectors.sidebarToggle).hide();
        }, 100);
    }
});

// Hide sidebar toggle for all users in list views (sidebar is removed via CSS marker class)
frappe.listview_settings['*'] = {
    onload: function(listview) {
        setTimeout(() => {
            $(selectors.sidebarToggle).hide();
        }, 100);
    }
};